import React from 'react'
import Tr from 'translations/Translations';
import IconButton from './IconButton';
import DragIndicator from '@material-ui/icons/DragHandle';

function IconDragButton({
	tooltip = Tr('move_part'),
	...props
}) {
	return <IconButton
		tooltip={tooltip}
		Icon={DragIndicator}
		{...props}
	/>
}

export default IconDragButton;